import type { ClientEvent, ClientSnapshot } from '@lw/client-core';
import { devTag } from '../runtime/identity.js';

export const pad = (n: number, w = 2): string => String(n).padStart(w, '0');

export function fmtTime(ms: number | null | undefined, frac = false): string {
  if (ms === null || ms === undefined) return '—';
  const d = new Date(ms);
  const base = `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
  return frac ? `${base}.${Math.floor(d.getUTCMilliseconds() / 100)}` : base;
}

export function fmtMMSS(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 60)}:${pad(s % 60)}`;
}

/** "acted by user@devtag" for the last event of the given types. */
export function actedBy(events: readonly ClientEvent[], ...types: string[]): string | null {
  for (let i = events.length - 1; i >= 0; i--) {
    const e = events[i] as ClientEvent;
    if (types.includes(e.type) && e.actorRole !== 'SERVER') return `${e.actorUser ?? '?'}@${devTag((e as { actorDevice?: string | null }).actorDevice)}`;
  }
  return null;
}

export function targetLabel(s: ClientSnapshot | null): string {
  return s?.target?.value ?? '—';
}

export const MILESTONES = [
  { k: 'CFF', nm: 'Call for fire', own: 'UAV' },
  { k: 'SOLUTION', nm: 'Solution', own: 'FDC' },
  { k: 'PROGRAMMING', nm: 'Programming', own: 'FDC' },
  { k: 'LOADING', nm: 'Loading', own: 'FDC' },
  { k: 'WEAPON_READY', nm: 'Weapon ready', own: 'FDC' },
  { k: 'UAV_READY', nm: 'UAV ready', own: 'UAV' },
  { k: 'FIRE', nm: 'Fire', own: 'FDC' },
  { k: 'COUNTDOWN', nm: 'Countdown', own: 'ALL' },
  { k: 'LASER_ON', nm: 'Laser on', own: 'UAV' },
  { k: 'IMPACT', nm: 'Impact', own: 'ALL' },
  { k: 'LASER_OFF', nm: 'Laser off', own: 'UAV' },
] as const;

const PRE = ['IDLE', 'CFF', 'SOLUTION', 'PROGRAMMING', 'LOADING', 'WEAPON_READY', 'UAV_READY'];

/** index of the current milestone in MILESTONES (−1 = none / IDLE) */
export function milestoneIndex(s: ClientSnapshot, now: number | null): number {
  const st = s.state;
  if (st === 'IDLE' || st === 'SAVED' || st === 'DISCARDED') return -1;
  const i = PRE.indexOf(st);
  if (i >= 1) return i - 1; // CFF → 0 … UAV_READY → 5
  if (st === 'FIRE_REVIEW') return 6;
  const tl = s.timeline;
  if (st === 'IN_FLIGHT' && tl && now !== null) {
    if (now < tl.tLaserOn) return 7;
    if (now < tl.tImpact) return 8;
    return 9;
  }
  if (st === 'AWAITING_DISPOSITION') return s.uav.laserOffAt ? 11 : 10;
  return 6;
}
